import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../hooks/hooks';
import { pages } from '../../../../redux/pages/action';
import { format } from '../../../../common/services/date.service';
import { layouts } from '../../../../redux/layouts/action';
import { selectLayoutListItems } from '../../../../redux/layouts/selector';
import WebsitesPageComponent from '../components/website-page/website-page.component';
import PageLoader from '../../../../components/PageLoader';
import storePersist from '../../../../redux/storePersist';
import { selectnetworksListItems } from '../../../../redux/networks/selector';
import { networks } from '../../../../redux/networks/action';
import * as R from "ramda"
const WebsitePage= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const {websiteId, id} = useParams()
  const routeQuery = useSelector(selectLayoutListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const networkItems = useSelector(selectnetworksListItems)
  var tenantId = storePersist?.get("tokenData")?.current?.result?.TokenMetadata?.TenantId;
  const [pageData, setPageData] = useState(1)
  const [
    layout,
    setLayouts
  ] = useState<any>([])

  const [
    selectedPages,
    setSelectedPages
  ] = useState<any>({PlatformWebsiteId: websiteId, TenantId:tenantId }
  )
 
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer (params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Message.LayoutName', headerName: 'Layout Name', sortable: true, filter: true },
      { field: 'Message.PageName', headerName: 'Page Name' },
      { field: 'Message.LayoutVersionId', headerName: 'Layout Version' },
  
    ]);
  }

  const fetchWebsitePageById= ()=>{
    dispatch(layouts.list({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-layouts/list`,entity:'layouts',jsonData:{     
        "Filters": [
            {
              "FieldName": "PlatformWebSitePageId",
              "FilterOperatorId": 1,
              "FieldValue": id,
              "FieldType": "number"
            }
          ],
          "PageNumber": pageData,
            "PageSize": 10,
            "SortField": "Id",
            "SortOrder": "desc",
}})).then(()=>{
  setIsQuery(true)
})

  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedPages({ ...selectedPages, [field]: event });
  }

  const handleFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedPages({ ...selectedPages, [fields[0]]: value });
  }
  useEffect(
    () => {
   dispatch(networks.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/networks/list`,entity:'endpoints',jsonData:{}}))
        
    if (Number(id) > 0) {
        fetchWebsitePageById()
   
        createColumnDefs()
        setIsLoading(false)
      }
      else{
        setIsLoading(false)
      }

  },
    [pageData]
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setLayouts(routeQuery?.result?.items)
      }
    },
    [isQuery]
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    await dispatch(pages.resetAction({ actionType: 'create' }))
      await dispatch(pages.create({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-pages`,entity:'pages',jsonData:{
          
      Records: [
        {
        
          "context": {},
          "message": {
            ...selectedPages
          }
      }
      ]
    
  }})).then(()=>{
    back()
  })
  }

const back=()=>{
  navigate(`/web-platform/websites/platform-website/${websiteId}`)
} 
const handleAdd=()=>{
    navigate(`platform-website-layout/${0}`)
  }
const handleEdit=(data: any)=>{
    navigate(`platform-website-layout/${data?.Message?.Id}`)
   }
   
   const additionButtons: any = [
    {
      name: 'Add Layouts',
      callback: () => handleAdd(),
    },
    {
      name: 'Back',
      callback: () => back(),
    }
  ];

    return (
    <>
      {isLoading ? <PageLoader /> : 
          <WebsitesPageComponent 
           handleInnerFormChange={handleInnerFormChange}
           selectedPages={selectedPages}
           back={back}
           handleFormSubmit={handleFormSubmit}
           id={id}
           columnDefs={columnDefs}
           onEdit={handleEdit}
           layout ={layout}
           additionButtons={additionButtons}
           paginationData={routeQuery?.result?.pagination}
           setPageData={setPageData}
           networks={networkItems?.result?.items}
           handleFormChange={handleFormChange}
          />  
    }
          </>
    )
    
    }
   
    export default WebsitePage;